import { baseApi } from "./baseApi";

const BASE_URL = "/branch-tally-upload";
const tags = [{ type: "BranchTallyUpload", id: "LIST" }];

const branchTallyUploadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listBranchTallyUploads: builder.query({
      query: (params) => ({ url: BASE_URL, params }),
      providesTags: (result) => result?.data
        ? [...result.data.map(({ _id }) => ({ type: "BranchTallyUpload", id: _id })), ...tags]
        : tags,
    }),
    getBranchTallyUpload: builder.query({
      query: (id) => `${BASE_URL}/${id}`,
      providesTags: (_result, _error, id) => [{ type: "BranchTallyUpload", id }],
    }),
    createBranchTallyUpload: builder.mutation({
      query: (body) => ({ url: BASE_URL, method: "POST", body }),
      invalidatesTags: tags,
    }),
    addMissingBranchTallyUploads: builder.mutation({
      query: () => ({ url: `${BASE_URL}/add-missing-branches`, method: "POST" }),
      invalidatesTags: tags,
    }),
    listAvailableBranchTallyUploadBranches: builder.query({
      query: () => `${BASE_URL}/available-branches`,
    }),
    updateBranchTallyUpload: builder.mutation({
      query: ({ id, ...body }) => ({ url: `${BASE_URL}/${id}`, method: "PUT", body }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "BranchTallyUpload", id }, ...tags],
    }),
    listBranchTallyUploadAttachments: builder.query({
      query: ({ id, ...params }) => ({ url: `${BASE_URL}/${id}/attachments`, params }),
      providesTags: (_result, _error, { id }) => [{ type: "BranchTallyUpload", id }],
    }),
    addBranchTallyUploadAttachments: builder.mutation({
      query: ({ id, attachments }) => ({ url: `${BASE_URL}/${id}/attachments`, method: "POST", body: { attachments } }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "BranchTallyUpload", id }, ...tags],
    }),
    updateBranchTallyUploadAttachmentStatus: builder.mutation({
      query: ({ id, attachmentId, isActive }) => ({ url: `${BASE_URL}/${id}/attachments/${attachmentId}`, method: "PATCH", body: { isActive } }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "BranchTallyUpload", id }],
    }),
  }),
});

export const {
  useLazyListBranchTallyUploadsQuery,
  useGetBranchTallyUploadQuery,
  useCreateBranchTallyUploadMutation,
  useAddMissingBranchTallyUploadsMutation,
  useLazyListAvailableBranchTallyUploadBranchesQuery,
  useUpdateBranchTallyUploadMutation,
  useLazyListBranchTallyUploadAttachmentsQuery,
  useAddBranchTallyUploadAttachmentsMutation,
  useUpdateBranchTallyUploadAttachmentStatusMutation,
} = branchTallyUploadApi;
